import React, { createContext, useContext } from 'react';

export const EmailEditorContext = createContext();

export const useEmailEditorContext = () => useContext(EmailEditorContext);

export const EmailEditorProvider = (props) => {
  const {
    dynamicContent,
    productData,
    invalidTag,
    setInvalidTag,
    senderInfo,
    children,
    template,
    contactEmail,
    visible,
    requestSampleData,
    setRequestSampleData,
  } = props;

  return (
    <EmailEditorContext.Provider
      value={{
        dynamicContent,
        invalidTag,
        setInvalidTag,
        productData,
        senderInfo,
        template,
        contactEmail,
        visible,
        requestSampleData,
        setRequestSampleData,
      }}
    >
      {children}
    </EmailEditorContext.Provider>
  );
};
